const getViewStopsMessageId = (isCollapsed, hasTSIData, hasPoints, transportMode) => {
  if (!hasTSIData)
    return "intermediateCallingPoints.stopsUnavailable";
  if (!hasPoints) {
    switch (transportMode) {
      case "bus":
        return "intermediateCallingPoints.directBus";
      case "ferry":
        return "intermediateCallingPoints.directFerry";
      case "train":
      default:
        return "intermediateCallingPoints.directTrain";
    }
  }
  if (isCollapsed)
    return "intermediateCallingPoints.showStops";
  return "intermediateCallingPoints.hideStops";
};
const getViewEarlierStopsMessageId = () => {
  return "not implemented yet";
};
const getViewLaterStopsMessageId = () => {
  return "not implemented yet";
};
const getTSIViewStopsToggleMessagesByType = (type) => {
  let getMessageId;
  switch (type) {
    case "preOrigin":
      getMessageId = getViewEarlierStopsMessageId;
      break;
    case "postDestination":
      getMessageId = getViewLaterStopsMessageId;
      break;
    case "intermediate":
    default:
      getMessageId = getViewStopsMessageId;
      break;
  }
  return getMessageId;
};
var getTSIViewStopsToggleMessagesByType_default = getTSIViewStopsToggleMessagesByType;
export {
  getTSIViewStopsToggleMessagesByType_default as default
};
